let img_1 = require('./640x100.svg')
let img_2 = require('./640x1280.svg')
let img_3 = require('./720x480.svg')
let img_4 = require('./720x1080.svg')
let img_5 = require('./720x1280.svg')
let img_6 = require('./800x400.svg')
let img_7 = require('./800x480.svg')
let img_8 = require('./800x800.svg')
let img_9 = require('./960x320.svg')
let img_10 = require('./960x480.svg')
let img_11 = require('./1080x1600.svg')
let img_12 = require('./1280x720.svg')
let img_13 = require('./800x600.svg')

module.exports = {
    img_1,
    img_2,
    img_3,
    img_4,
    img_5,
    img_6,
    img_7,
    img_8,
    img_9,
    img_10,
    img_11,
    img_12,
    img_13
}